// @ts-check

import { escape as escapeHtml } from 'lodash';
import { splitMatches } from './splitMatches';

/**
 * Escapes `value` as HTML text and wraps each match of `query`, as {@link splitMatches} finds them, in `openTag` and `closeTag`.
 * @param {unknown} value
 * @param {unknown} query
 * @param {string} openTag
 * @param {string} closeTag
 * @returns {string}
 */
export function highlightMatches(value, query, openTag, closeTag) {
  return splitMatches(value, query)
    .map(piece => (piece.isMatch ? openTag + escapeHtml(piece.text) + closeTag : escapeHtml(piece.text)))
    .join('');
}
